import React from 'react';

import { Fab } from '@mui/material';
import { IconBtn } from './Component.style';

const BasicIconButton = ({ icon, onClick, ariaLabel, iconType, ...others }) => {
  if (iconType === 'fab') {
    return (
      <Fab aria-label={ariaLabel} onClick={onClick} {...others}>
        {icon}
      </Fab>
    );
  }
  return (
    <IconBtn aria-label={ariaLabel} onClick={onClick} {...others}>
      {icon}
    </IconBtn>
  );
};
export default BasicIconButton;
